import { post } from "@utils/httpUtil";
// 查询社区咨询服务的新增咨询数据看板
export function findCommunityConsultServiceAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityConsultServiceAddBoard`, data, config);
}
// 查询社区咨询服务的累计咨询数据看板
export function findCommunityConsultServiceAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityConsultServiceAccumulatedBoard`, data, config);
}
// 查询社区服务数据-处方服务的新增数据看板
export function findCommunityPrescriptionServiceAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityPrescriptionServiceAddBoard`, data, config);
}
// 查询社区服务数据-处方服务的累计数据看板
export function findCommunityPrescriptionServiceAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityPrescriptionServiceAccumulatedBoard`, data, config);
}
// 查询社区服务数据-药品销售新增数据看板
export function findCommunityDrugSaleAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityDrugSaleAddBoard`, data, config);
}
// 查询社区服务数据-药品销售累计数据看板
export function findCommunityDrugSaleAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityDrugSaleAccumulatedBoard`, data, config);
}
// 查询社区服务数据-线下面诊的新增数据看板
export function findCommunityOfflineDiagnosisAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityOfflineDiagnosisAddBoard`, data, config);
}
// 查询社区服务数据-线下面诊的累计数据看板
export function findCommunityOfflineDiagnosisAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityOfflineDiagnosisAccumulatedBoard`, data, config);
}
// 查询社区服务数据-检测咨询的新增数据看板
export function findCommunityDetectionConsultAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityDetectionConsultAddBoard`, data, config);
}
// 查询社区服务数据-检测咨询的累计数据看板
export function findCommunityDetectionConsultAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityDetectionConsultAccumulatedBoard`, data, config);
}
// 查询社区服务数据-预约到店的新增数据看板
export function findCommunityAppointmentArrivalAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityAppointmentArrivalAddBoard`, data, config);
}
// 查询社区服务数据-预约到店的累计数据看板
export function findCommunityAppointmentArrivalAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityAppointmentArrivalAccumulatedBoard`, data, config);
}
// 查询社区用户新增数据看板
export function findCommunityUserAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityUserAddBoard`, data, config);
}
// 查询社区用户累计数据看板
export function findCommunityUserAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityUserAccumulatedBoard`, data, config);
}
// 查询社区医生新增数据看板
export function findCommunityDoctorAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityDoctorAddBoard`, data, config);
}
// 查询社区医生累计数据看板
export function findCommunityDoctorAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityDoctorAccumulatedBoard`, data, config);
}
// 查询药品供应新增数据看板
export function findDrugSupplyAddBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findDrugSupplyAddBoard`, data, config);
}
// 查询药品供应累计数据看板
export function findDrugSupplyAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findDrugSupplyAccumulatedBoard`, data, config);
}
// 查询社区服务收入数据-新增数据看板
export function findCommunityServiceAwardBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityServiceAwardBoard`, data, config);
}
// 查询社区服务收入数据-累计数据看板
export function findCommunityServiceAwardAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findCommunityServiceAwardAccumulatedBoard`, data, config);
}
// 查询社区内容数据-新增数据看板
export function findHealthContentBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findHealthContentBoard`, data, config);
}
// 查询社区内容数据-累计数据看板
export function findHealthContentAccumulatedBoard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/findHealthContentAccumulatedBoard`, data, config);
}
// 通过社区登录
export function datartCommunityLogin(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/data/statistics/datart/community/login`, data, config);
}
